import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormGroup} from "@angular/forms";
import {RegistrationDto, RegistrationRequestOtpDto} from "../../types/registration.types";
import {SignUpService} from "../../service/sign-up.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {RegistrationApiService} from "../../api/registration-api.service";


@Component({
    selector: 'rg-base-component',
    templateUrl: './registration-base-component.html',
})
export class RegistrationBaseComponent extends CoreComponent {

  @Input() formGroup!: FormGroup;
  @Output() handleStepChange = new EventEmitter<number>;

  constructor(protected registrationApiService: RegistrationApiService,
              protected signUpService: SignUpService,
              protected coreApiService: CoreApiService) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }
  /**
   * Refresh Component.
   */
  refreshComponent() {

    this.initialized = true;
  }

  /**
   * Process changes within Binding.
   * @param changes
   */
  override ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["id"]) {
      this.refreshComponent();
    }
  }

  /**
   * Destroy component.
   */
  override ngOnDestroy(): void {

  }

  protected isActiveFormValid(controlsToCheck: string[]): boolean {
    for (const controlName of controlsToCheck) {
      const control = this.formGroup.get(controlName);
      if (!control || control.invalid) {
        return false;
      }
    }
    return true;
  }

  navigateNextStep(currentStep: number) {
    currentStep++;
    this.handleStepChange.emit(currentStep);
  }

  navigatePreviousStep(currentStep: number) {
    currentStep--;
    this.handleStepChange.emit(currentStep);
  }

  updateRegistration(removePassword: boolean = true) {
    if (this.busy) {
      return;
    }

    this.busy = true;
    this.disableFormGroup();

    const dto: RegistrationRequestOtpDto & RegistrationDto &  {[key: string]: any} = {};

    for (let key in this.formGroup.value) {

      if ((key == "password" || key == "confirmPassword") && removePassword) {
        continue;
      }

      dto[key] = this.formGroup.value[key];
    }

    // 18.03.2025 Change Birth Date to UTC
    if (dto["dateOfBirth"]) {
      // convert to UTC date
      dto["dateOfBirth"] = new Date(Date.UTC(dto["dateOfBirth"].getFullYear(), dto["dateOfBirth"].getMonth(), dto["dateOfBirth"].getDate()));
    }


    this.registrationApiService.update(dto).subscribe(res => {
      this.postObjectRefresh();
      this.enableFormGroup();
      this.busy = false;
    }, error => {
      this.enableFormGroup();
    });
  }

  postObjectRefresh() {
  }

  enableFormGroup() {
    this.formGroup.enable();
  }

  disableFormGroup() {
    this.formGroup.disable();
  }

}
